// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"5424dfa6","587":"d5ad1124","832":"82912704"}[chunkId] + ".css";
};